module.exports = __webpack_public_path__ + "img/pass.06aae720.png";